import { Search, BookOpen, Brain, Briefcase } from 'lucide-react';

export const tools = [
  {
    id: 'researcher',
    name: 'AI Legal Researcher',
    icon: Search,
    description: 'Research case law, legal principles, and precedents',
    available: true
  },
  {
    id: 'builder',
    name: 'AI Case Builder',
    icon: BookOpen,
    description: 'Build comprehensive legal arguments and case strategies',
    available: false
  },
  {
    id: 'predictor',
    name: 'AI Case Predictor',
    icon: Brain,
    description: 'Predict case outcomes based on historical data',
    available: false
  },
  {
    id: 'manager',
    name: 'AI Case Manager',
    icon: Briefcase,
    description: 'Manage and organize your cases efficiently',
    available: false
  }
];